import { WATERS_API_URL, SERVER_URL } from "../Consts/config";
import { get } from ".";

const getWaters = async () =>
  await get(`${SERVER_URL}${WATERS_API_URL}`, {
    showIn: "website",
  });

export { getWaters };
